import FullPageLoading from "components/FullPageLoading"
import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import routes from "routes"
import { getPlatformURL, sleep } from "utils/helpers"
import useHideGlobalBottomNavigation from "utils/hooks/useGlobalHideBottomNavigation"
import useHideTopNavigation from "utils/hooks/useHideTopNavigation"
import { trackingService } from "utils/tracking"
import { HubSpotTrackingEvents, TrackingEvents } from "utils/tracking/events"

const parseStringToInt = (value: string | null) => {
  if (!value) return value
  const parsed = parseInt(value, 10)
  return isNaN(parsed) ? value : parsed
}

const trackPurchaseSuccess = () => {
  const params = new URLSearchParams(window.location.search)
  const data = {
    product_id: parseStringToInt(params.get("product_id")),
    subscription_type: params.get("subscription_type"),
    status: "completed",
    currency: params.get("currency"),
    price: parseStringToInt(params.get("price")),
    is_userless: params.get("order_token") ? "true" : "false",
  }

  trackingService.trackEvent(TrackingEvents.suraasaPlusPaymentCompleted, data, {
    services: ["PostHog", "GA"],
  })
  trackingService.trackEvent(TrackingEvents.productPurchaseStatus, data, {
    services: ["PostHog"],
  })
  trackingService.trackEvent(
    HubSpotTrackingEvents.productPurchaseStatus,
    data,
    {
      services: ["HubSpot"],
    }
  )
}

const processRedirect = () => {
  const params = new URLSearchParams(window.location.search)
  params.delete("order_status")

  const redirectUrl = new URL(routes.home, window.location.origin)

  const isUserless = params.get("order_token") ? true : false

  if (isUserless) {
    const verificationPage = new URL(getPlatformURL("sso", "/spny/verify"))
    params.set("redirect-url", redirectUrl.toString())
    verificationPage.search = params.toString()
    console.log(`Redirecting to verification: ${verificationPage.toString()}`)
    window.location.replace(verificationPage.toString())
    return
  }

  console.log(`Redirecting: ${redirectUrl.toString()}`)
  window.location.replace(redirectUrl.toString())
}

// order_token, email, phone_number, dial_code, first_name, last_name
const SuraasaPlusPaymentSuccessPage = () => {
  useHideGlobalBottomNavigation()
  useHideTopNavigation()

  const [searchParams] = useSearchParams()

  useEffect(() => {
    const run = async () => {
      if (searchParams.get("order_status") === "success") {
        trackPurchaseSuccess()
        await sleep(2000)

        processRedirect()
      }
    }

    run()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <FullPageLoading
      message="Processing your payment. You will be redirected automatically..."
      debugMessage="From SuraasaPlusPaymentSuccessPage"
    />
  )
}

export default SuraasaPlusPaymentSuccessPage
